import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['seller-oss'], // 为了获取基础路由
    };
};
// 预防供应链的路由被篡改，可以被供应链的路由指向过去
const settleObj = Number(sessionStorage.getItem('pt')) === 0
    ? {
        settle1010: ({ businessKey }) => commonFunc(`/procurement/payment/detail?id=${businessKey}`),
    }
    : {};
export const sellerToPathNameMap = {
    // 消费定价
    mch1010: ({ businessKey }) => commonFunc(`/billing/consumer-pricing/${businessKey}/detail`),
    // 采购定价
    mch1020: ({ businessKey }) => commonFunc(`/billing/purchase-pricing/${businessKey}/detail`),
    // 使用限额
    mch1030: ({ businessKey }) => commonFunc(`/billing/configuration/usage-limit/${businessKey}/detail`),
    // 账单规则
    mch1040: ({ businessKey }) => commonFunc(`/billing/configuration/rules/${businessKey}/detail`),
    // 渠道费率配置
    payCenter1001: ({ businessKey }) => commonFunc(`/payment/rate-configuration/${businessKey}/detail`),
    // 付款单 与供应链的付款单业务编号一致
    ...settleObj,
};
